import { createPopper } from '@popperjs/core';

const tooltips = document.querySelectorAll('.js-tooltip');

const showPopper = (tooltip) => {
    tooltip.setAttribute('show-popper', '');
    tooltip.setAttribute('aria-expanded', 'true');
};

const hidePopper = (tooltip) => {
    tooltip.removeAttribute('show-popper');
    tooltip.setAttribute('aria-expanded', 'false');
};

const togglePopper = (tooltip) => {
    if (tooltip.hasAttribute('show-popper')) {
        hidePopper(tooltip);
    } else {
        showPopper(tooltip);
    }
};

const init = () => {
    if (tooltips.length === 0) return;

    tooltips.forEach((tooltip) => {
        const button = tooltip.parentNode.querySelector('.js-tooltip-btn');
        const popperInstance = createPopper(button, tooltip, {
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [0, 20],
                    },
                },
            ],
        });

        button.addEventListener('click', () => {
            popperInstance.update();
            togglePopper(tooltip);
        });
    });

    const tooltipBtns = document.querySelectorAll('.js-tooltip-btn');
    document.addEventListener('click', (e) => {
        tooltipBtns.forEach((tooltipBtn, index) => {
            let targetElement = e.target; // clicked element

            do {
                if (targetElement === tooltipBtn) {
                    // a click inside
                    return;
                }
                // go up the DOM
                targetElement = targetElement.parentNode;
            } while (targetElement);

            // a click outside
            hidePopper(tooltips[index]);
        });
    });
};

export default init;
